// extracted by mini-css-extract-plugin
module.exports = {"container":"kd","hero":"ld","content":"md","typeProd":"nd","notTransparent":"od","sliderDots":"pd","active":"qd"};